import script from "./surveyResult.vue?vue&type=script&setup=true&lang=js"
export * from "./surveyResult.vue?vue&type=script&setup=true&lang=js"

import "./surveyResult.vue?vue&type=style&index=0&id=0f9a3476&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9a3476"]])

export default __exports__